'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHeartbeatState = setHeartbeatState;
exports.heartbeat = heartbeat;

var _xr = require('xr');

var _xr2 = _interopRequireDefault(_xr);

var _getAppInfo2 = require('./getAppInfo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEARTBEAT_STATE = {};

function setHeartbeatState(state) {
  HEARTBEAT_STATE = state;
}

function heartbeat(url) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;

  var _getAppInfo = (0, _getAppInfo2.getAppInfo)(),
      tracking = _getAppInfo.tracking,
      version = _getAppInfo.version;

  if (tracking == null) return;

  setInterval(function () {
    _xr2.default.post(url, { tracking: tracking, version: version, state: HEARTBEAT_STATE }).then(function (res) {
      if (res.data.refresh) location.reload();
    }, function (res) {
      return console.error('heartbeat fail', res);
    });
  }, interval);
}

if (window.HEARTBEAT_URL) {
  heartbeat(window.HEARTBEAT_URL);
}


//////////////////
// WEBPACK FOOTER
// ./~/dooh-utils/dist/hearbeat.js
// module id = 65
// module chunks = 0